import { locale } from "../locale";
import { br, h1, p } from "../van/van-tags";
import { centeredBox } from "../view/components";

/**
 * @param {import("navigo").Match} _ctx
 */
export async function warrantyPage(_ctx) {
	return centeredBox(
		"large",
		h1(
			{
				class: "title",
			},
			locale.string({
				enGB: "Warranties",
				deDE: "Garantien",
				frFR: "Garanties",
				svSE: "Garantier",
			}),
		),
		p(
			locale.string({
				enGB: "The extended warranty period is always included; product registration is no longer necessary to receive it.",
				deDE: "Die erweiterte Garantiezeit ist immer inbegriffen; eine Produktregistrierung ist nicht länger notwendig, um sie zu erhalten.",
				frFR: "La période de garantie prolongée est toujours incluse ; l'enregistrement du produit n'est plus nécessaire pour en bénéficier.",
				svSE: "Den utökade garantitiden ingår alltid; produktregistrering är inte längre nödvändig för att få den.",
			}),
		),
		br(),
		p(
			locale.string({
				enGB: "However, a valid proof of purchase is still required when a warranty claim is made. A valid proof of purchase must contain the vendor, date, and proof that payment has been made.",
				deDE: "Ein gültiger Kaufbeleg ist jedoch weiterhin erforderlich, wenn ein Garantieanspruch geltend gemacht wird. Ein gültiger Kaufbeleg muss den Verkäufer, das Datum und einen Zahlungsnachweis enthalten.",
				frFR: "Cependant, une preuve d'achat valide est toujours requise lors d'une réclamation au titre de la garantie. Une preuve d'achat valide doit contenir le fournisseur, la date et la preuve que le paiement a été effectué.",
				svSE: "Ett giltigt köpbevis krävs dock fortfarande när ett garantianspråk görs. Ett giltigt köpbevis måste innehålla säljaren, datumet och bevis på att betalning har gjorts.",
			}),
		),
	);
}
